import { createContext, useContext } from "react";

// Where the lane body portals its hover cards and link handles. Normally
// document.body; a full-screen lane supplies its own element, because it is
// pinned above the page at z-[999] and body portals would render behind it.
export const PlannerPortalContext = createContext<HTMLElement | null>(null);

export function usePlannerPortalTarget(): HTMLElement {
  return useContext(PlannerPortalContext) ?? document.body;
}
